module.exports = __webpack_public_path__ + "images/map-style-5-45803b7a4803b78e63d78d46138d484c.jpg";